<template>
  <div class="student-side-menu">
    <div class="user-info">
      <a-avatar
        style="backgroundcolor: #87d068; border-radius: 50%; padding: 0"
        shape="square"
        icon="user"
        :src="avatarUrl"
      />
      <h3 style="margin-top: 10px">
        {{ $store.state.user ? $store.state.user.info.realname : "" }}
      </h3>
    </div>
    <a-divider style="width: 80%"></a-divider>
    <div v-if="userIdentity == 1">
      <a-menu mode="inline" @click="handleClick" v-model="selectedKeys">
        <a-menu-item key="practise">
          <router-link to="practise"
            ><i class="iconfont">&#xe672;</i>我的练习</router-link
          >
        </a-menu-item>
        <a-menu-item key="takeanexam">
          <router-link to="takeanexam"
            ><i class="iconfont">&#xe679;</i>我的考试</router-link
          >
        </a-menu-item>
        <a-menu-item key="wrongQuestion">
          <router-link to="wrongQuestion"
            ><i class="iconfont">&#xe77f;</i>错题本</router-link
          >
        </a-menu-item>
      </a-menu>
    </div>
    <div v-if="userIdentity == 2">
      <a-menu mode="inline" @click="handleClick" v-model="selectedKeys">
        <a-sub-menu key="index">
          <template slot="title">
            <span class="menuTitle"
              ><i class="iconfont">&#xe672;</i>题库中心</span
            >
          </template>
          <a-menu-item key="questionBankPt" class="ziMenu"
            ><router-link to="questionBank?type=1"
              >平台题库</router-link
            ></a-menu-item
          >
          <a-menu-item key="questionBankXq" class="ziMenu"
            ><router-link to="questionBank?type=2"
              >校区题库</router-link
            ></a-menu-item
          >
        </a-sub-menu>
        <a-sub-menu key="shijuna">
          <template slot="title">
            <span class="menuTitle"
              ><i class="iconfont">&#xe679;</i>试卷中心</span
            >
          </template>
          <a-menu-item key="testPaper" class="ziMenu"
            ><router-link to="testPaper">试卷管理</router-link></a-menu-item
          >
        </a-sub-menu>
        <a-sub-menu key="kaoshi">
          <template slot="title">
            <span class="menuTitle"
              ><i class="iconfont">&#xe659;</i>练习/考试</span
            >
          </template>
          <a-menu-item key="studentPractice" class="ziMenu"
            ><router-link to="studentPractice"
              >学员练习</router-link
            ></a-menu-item
          >
          <a-menu-item key="studentExams" class="ziMenu"
            ><router-link to="studentExams">学员考试</router-link></a-menu-item
          >
        </a-sub-menu>
      </a-menu>
    </div>
  </div>
</template>
    
    <script>
import Vue from "vue";
import config from "../theme.config";
import { getQiniuUrl } from "@/utils/qiniu.js";
import { ACCESS_TOKEN } from "@/store/mutation-types";
export default {
  name: "mockSideMenu",
  data() {
    return {
      selectedKeys: ["index"],
      userCountInfo: {},
      token: "",
    };
  },
  components: {},
  watch: {
    $route(to, from) {
      this.selectedKeys[0] = to.meta.key ? this.selectedKeys[0] : to.name;
      this.$forceUpdate();
    },
  },

  computed: {
    avatarUrl() {
      if (this.$store.state.user.avatar) {
        return this.$store.state.user.avatar;
      } else if (
        this.$store.state.user.info &&
        this.$store.state.user.info.avatar
      ) {
        return this.$store.state.user.info.avatar;
      } else {
        return "/img/avatar.png";
      }
    },
    userIdentity() {
      return this.$store.state.user.info.userIdentity;
    },
  },
  created() {
    this.selectedKeys[0] = this.$route.meta.key || this.$route.name;
    this.token = Vue.ls.get(ACCESS_TOKEN);
  },
  methods: {
    getQiniuUrl,
    toBackend() {
      if (this.$store.getters.tenantInfo.backendUrl) {
        window.location.href =
          this.$store.getters.tenantInfo.backendUrl +
          "/dashboard/index?token=" +
          this.token;
      } else {
        alert("暂未开放");
      }
    },
    handleClick(e) {},
  },
};
</script>
    
  <style lang="less" scoped>
@import "~@assets/iconfont.css";
.student-side-menu {
  padding-bottom: 20px;
}
.user-info {
  // background-image: url("~@assets/theme/xmw/user-info-bg.png");
  background-size: cover;
  padding-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .school-area {
    font-size: 14px;
    color: #999;
  }
  .medal {
    width: 40px;
    margin-bottom: 10px;
  }
}
.ant-avatar {
  width: 80px;
  height: 80px;
  padding: 5px;
  background: #fff !important;
}
.ant-menu-item {
  a,
  i {
    font-size: 18px;
  }
}
.menuTitle {
  font-size: 18px;
  a,
  i {
    font-size: 18px;
  }
}
.ziMenu {
  a,
  i {
    font-size: 16px;
  }
}
</style>